import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TKyuyuryoGetListReq,
  TKyuyuryoGetListRes,
  TKyuyuryoPutReq,
} from "./TKyuyuryo"

/**
 * 給油量に対するAPIリクエスト用サービス
 *
 * @export
 * @class KyuyuryoService
 * @extends {ConnectApi}
 */
export default class KyuyuryoService extends ConnectApi {
  /**
   * 給油量 一覧取得
   *
   * @param {TKyuyuryoGetListReq} params
   * @memberof KyuyuryoService
   */
  getList = async (params: TKyuyuryoGetListReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TKyuyuryoGetListRes[]>> =
        await this.getInner(`/truckcontrol/kyuyuryo/list`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 給油量 更新
   *
   * @param {TKyuyuryoPutReq} data
   * @memberof KyuyuryoService
   */
  put = async (id: number, data: TKyuyuryoPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `truckcontrol/kyuyuryo/list/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
